module.exports = __webpack_public_path__ + "img/V46.e02be748.jpg";